import { render, staticRenderFns } from "./ArticleExam.vue?vue&type=template&id=501be1c5&scoped=true&"
import script from "./ArticleExam.vue?vue&type=script&lang=js&"
export * from "./ArticleExam.vue?vue&type=script&lang=js&"
import style0 from "./ArticleExam.vue?vue&type=style&index=0&id=501be1c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501be1c5",
  null
  
)

component.options.__file = "ArticleExam.vue"
export default component.exports